"use client";

import clsx from "clsx";
import { SimpleSheet } from "@/components/simple-sheet/simple-sheet";
import { useSmallViewport } from "@/components/viewport";
import { STRINGS } from "@/constants/strings";
import { InfoIcon } from "@/theme/icons/info";
import {
  TYPOGRAPHY_BODY3_SENTENCE,
  TYPOGRAPHY_BODY3_BOLD,
} from "@/theme/topshop/typography/typography-constants";
import classes from "./shipped-by.module.css";

type ShippedByProps = {
  sellerName: string;
  className?: string;
  sources?: string[];
};

export const ShippedBy = ({
  sellerName,
  className,
  sources,
}: ShippedByProps) => {
  const isMobile = useSmallViewport();
  const isMultiSource = sources && sources.length > 0;
  const sheetTitle = `${STRINGS.seller.shippedBy} ${sellerName}`;
  const infoText = STRINGS.seller.flexiInfo.replace("{seller}", sellerName);
  const [multiPrefix, multiSuffix] =
    STRINGS.seller.multiShippedBy.split("{seller}");

  return (
    <div
      className={clsx(classes.shippedBy, className)}
      data-testid="shipped-by-label"
    >
      <span className={TYPOGRAPHY_BODY3_SENTENCE}>
        {isMultiSource ? (
          <>
            {multiPrefix}
            <strong className={`${TYPOGRAPHY_BODY3_BOLD} ${classes.nowrap}`}>
              {sellerName}
            </strong>
            {multiSuffix}
          </>
        ) : (
          <>
            {STRINGS.seller.shippedBy}{" "}
            <strong className={TYPOGRAPHY_BODY3_BOLD}>{sellerName}</strong>
          </>
        )}
      </span>
      <SimpleSheet
        position={isMobile ? "bottom" : "center"}
        title={sheetTitle}
        description={infoText}
        trigger={<InfoIcon label={`Fulfilment info for ${sellerName}`} />}
        triggerClassName={classes.infoTrigger}
      >
        <p
          className={`${classes.sheetDescription} ${TYPOGRAPHY_BODY3_SENTENCE}`}
        >
          {infoText}
        </p>
      </SimpleSheet>
    </div>
  );
};
